import moment, { Moment } from 'moment-timezone';

import ApiOrder from 'types/api/Order';

import Currency from 'models/Currency';
import { Timezone } from 'models/Market';
import Model from 'models/Model';
import OrderItem from 'models/OrderItem';
import OrderProduct from 'models/OrderProduct';

import { getFormattedDate } from 'utils/date';
import { changeFromCent, displayPrice } from 'utils/math';

export enum UserTypes {
    Private = 'private',
    Comapny = 'company',
}

export enum Statuses {
    New = 'new',
    Active = 'active',
    Done = 'done',
    Canceled = 'canceled',
}

export enum CreateMethod {
    BuyNow = 'buyNow',
    Cart = 'cart',
}

export default class Order implements Model {
    id: string;
    createdAt: Moment;
    createdAtDisplay: string;
    name: string;
    currency: Currency;
    price: number;
    priceDisplay: string;
    products: OrderProduct[];
    items: OrderItem[];
    createMethod? : CreateMethod;

    constructor(data: ApiOrder) {
        this.id = data.id;
        this.createdAt = data.createdAt && moment.utc(data.createdAt).tz(Timezone);
        this.createdAtDisplay = this.createdAt && getFormattedDate(this.createdAt);
        this.name = data.name;
        this.currency = data.currency && new Currency(data.currency);
        this.price = changeFromCent(data.price);
        this.priceDisplay = displayPrice(this.price, this.currency);
        this.products = Array.isArray(data.products)
            ? data.products.map(product => new OrderProduct(product))
            : [];
        this.items = Array.isArray(data.items)
            ? data.items.map(item => new OrderItem(item))
            : [];
    }
}
